import { computed, reactive } from 'vue';
import ConversationToolsAPI from 'custom/api/conversationTools';

// Shared between the header's pin button and the pinned section of the conversation list
const state = reactive({ conversations: [], loaded: false, loading: false });

const load = async () => {
  if (state.loading) return;
  state.loading = true;
  try {
    const { data } = await ConversationToolsAPI.pinned();
    state.conversations = data.payload;
    state.loaded = true;
  } finally {
    state.loading = false;
  }
};

export function usePins() {
  const pinnedIds = computed(
    () => new Set(state.conversations.map(conversation => conversation.id))
  );

  const isPinned = id => pinnedIds.value.has(id);

  const toggle = async id => {
    if (isPinned(id)) await ConversationToolsAPI.unpin(id);
    else await ConversationToolsAPI.pin(id);
    await load();
  };

  if (!state.loaded) load();

  return {
    pinned: computed(() => state.conversations),
    isPinned,
    toggle,
    reload: load,
  };
}
